var _g, _path, _line, _line2, _line3, _line4, _line5, _rect, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayer4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 160,
    viewBox: "0 0 208 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2060_3760)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.44385,
    y: 74.3131,
    width: 125.379,
    height: 79.1869,
    rx: 8,
    transform: "rotate(-8.69553 4.44385 74.3131)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23365 79.4772C4.79745 76.6252 6.75589 73.9595 9.60794 73.5233L123.218 56.1476C126.07 55.7114 128.736 57.6698 129.172 60.5219L131.126 73.2962L7.18738 92.2515L5.23365 79.4772Z",
    fill: "#D9DDE9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 78.2472,
    y1: 118.343,
    x2: 123.297,
    y2: 111.453,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 76.3352,
    y1: 105.841,
    x2: 121.385,
    y2: 98.9506,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 74.423,
    y1: 93.3379,
    x2: 119.473,
    y2: 86.4479,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 80.1594,
    y1: 130.845,
    x2: 117.055,
    y2: 125.203,
    stroke: "#031A6B",
    strokeOpacity: 0.3,
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14.3532,
    y1: 82.4981,
    x2: 46.357,
    y2: 77.6034,
    stroke: "white",
    strokeWidth: 3.9181,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 99.7341,
    width: 44.5426,
    height: 44.5426,
    rx: 3,
    transform: "rotate(-8.69553 16 99.7341)",
    fill: "#D9DDE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8783 128.702C48.126 127.675 46.4693 126.448 45.9956 123.351C45.7113 121.492 46.9984 120.063 47.2563 118.393C47.5142 116.723 47.5158 114.793 47.5472 113.384C47.5785 111.975 47.5932 111.43 47.5007 109.948C47.3821 108.099 45.496 103.568 39.2624 104.521C33.0308 105.474 32.5816 110.363 33.0246 112.162C33.3793 113.604 33.5568 114.12 34.0073 115.455C34.4578 116.79 35.0335 118.632 35.7784 120.148C36.5232 121.665 38.1808 122.644 38.4651 124.503C38.9388 127.6 37.7246 129.266 33.4965 131.666C29.2526 134.073 26.5861 136.214 26.7691 137.411L27.6265 143.017L61.8725 137.779L61.0152 132.173C60.8325 130.979 57.6461 129.733 52.8783 128.702Z",
    fill: "#B3BAD3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2060_3760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.66 82.4335C194.63 90.9706 186.876 97.0572 178.338 96.0288L77.2689 83.8499C68.7317 82.8215 62.6452 75.0674 63.6736 66.5302L69.977 14.2118C71.0069 5.67459 78.7609 -0.411972 87.2981 0.617905L188.368 12.7953C196.905 13.8223 202.991 21.5778 201.963 30.115L195.66 82.4335Z",
    fill: "#E2E6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.635 68.6792L104.344 59.3661L104.49 58.1778L181.778 67.4896L181.635 68.6792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.774 75.8149L103.485 66.5018L103.629 65.3136L180.918 74.6253L180.774 75.8149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.724 69.8386L105.328 71.0411C105.486 71.3535 105.615 71.6402 105.752 71.9497L105.783 71.9526C105.993 71.663 106.194 71.4162 106.401 71.1595L107.261 70.1439L108.279 70.268L106.209 72.5588L107.707 75.4544L106.636 75.3261L106.017 74.068C105.85 73.7427 105.713 73.4346 105.569 73.1008L105.546 73.098C105.338 73.3875 105.122 73.6457 104.893 73.931L104.003 75.008L102.966 74.8839L105.124 72.4604L103.675 69.7116L104.724 69.8386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.679 70.4367L110.284 71.6392C110.442 71.9516 110.569 72.2383 110.706 72.5464L110.737 72.5507C110.947 72.2611 111.15 72.0129 111.355 71.7576L112.215 70.742L113.234 70.8647L111.164 73.1569L112.663 76.0526L111.592 75.9228L110.971 74.6647C110.806 74.3394 110.667 74.0313 110.525 73.6975L110.502 73.6961C110.294 73.9857 110.077 74.2424 109.849 74.5277L108.959 75.6061L107.92 75.4806L110.078 73.0585L108.631 70.3098L109.679 70.4367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.633 71.0327L115.238 72.2366C115.396 72.5475 115.524 72.8357 115.661 73.1423L115.693 73.148C115.902 72.8571 116.105 72.6089 116.31 72.355L117.171 71.3393L118.188 71.462L116.119 73.7529L117.617 76.6499L116.546 76.5201L115.927 75.262C115.76 74.9368 115.623 74.6287 115.479 74.2949L115.456 74.2935C115.248 74.5816 115.032 74.8398 114.803 75.1251L113.913 76.202L112.876 76.0765L115.034 73.6544L113.585 70.9057L114.633 71.0327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.589 71.6302L120.192 72.8327C120.352 73.1451 120.479 73.4318 120.616 73.7399L120.647 73.7442C120.857 73.4561 121.059 73.2079 121.265 72.9511L122.125 71.9355L123.143 72.0582L121.075 74.3504L122.573 77.2475L121.502 77.1177L120.881 75.8582C120.714 75.5344 120.579 75.2248 120.433 74.8925L120.412 74.8896C120.204 75.1792 119.988 75.4359 119.757 75.7226L118.868 76.7996L117.83 76.6741L119.988 74.252L118.54 71.5033L119.589 71.6302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.543 72.2262L125.148 73.4287C125.306 73.7411 125.433 74.0278 125.57 74.3374L125.601 74.3416C125.811 74.0521 126.015 73.8039 126.219 73.5485L127.08 72.5329L128.097 72.6542L126.029 74.9464L127.527 77.8435L126.457 77.7151L125.837 76.4556C125.67 76.1304 125.534 75.8223 125.389 75.4899L125.366 75.4871C125.159 75.7752 124.942 76.0319 124.713 76.3201L123.822 77.3956L122.784 77.2701L124.944 74.8494L123.494 72.0993L124.543 72.2262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.498 72.8239L130.103 74.0264C130.259 74.3388 130.389 74.6255 130.526 74.935L130.558 74.9379C130.767 74.6498 130.968 74.4016 131.175 74.1448L132.035 73.1292L133.052 73.2519L130.983 75.5427L132.48 78.4398L131.411 78.3114L130.791 77.0519C130.625 76.7281 130.488 76.4185 130.344 76.0862L130.321 76.0833C130.113 76.3729 129.897 76.6296 129.667 76.9163L128.777 77.9933L127.74 77.8678L129.899 75.4471L128.449 72.697L129.498 72.8239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.901 75.5631L135.816 76.2564L133.172 75.9397L133.256 75.2422L135.901 75.5631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.674 73.8089L138.279 75.0114C138.437 75.3237 138.564 75.6105 138.701 75.92L138.732 75.9228C138.942 75.6347 139.146 75.3865 139.35 75.1312L140.21 74.1141L141.229 74.2368L139.16 76.5291L140.658 79.4261L139.587 79.2963L138.966 78.0368C138.801 77.713 138.664 77.4035 138.519 77.0711L138.497 77.0683C138.289 77.3578 138.073 77.6146 137.842 77.9013L136.954 78.9782L135.915 78.8527L138.075 76.4321L136.624 73.6819L137.674 73.8089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.628 74.4063L143.233 75.6088C143.391 75.9212 143.519 76.2079 143.656 76.5174L143.686 76.5203C143.896 76.2307 144.1 75.9839 144.304 75.7272L145.166 74.7116L146.183 74.8342L144.114 77.1251L145.612 80.0222L144.542 79.8938L143.922 78.6343C143.755 78.3105 143.619 78.0009 143.474 77.6686L143.452 77.6657C143.244 77.9553 143.027 78.212 142.798 78.4987L141.908 79.5757L140.871 79.4502L143.029 77.0295L141.581 74.2794L142.628 74.4063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.584 75.0028L148.187 76.2052C148.346 76.5176 148.474 76.8043 148.611 77.1139L148.642 77.1167C148.852 76.8286 149.055 76.5804 149.26 76.3251L150.121 75.308L151.139 75.4321L149.07 77.723L150.567 80.62L149.497 80.4902L148.876 79.2321C148.709 78.9069 148.574 78.5974 148.428 78.265L148.407 78.2621C148.199 78.5531 147.983 78.8085 147.752 79.0952L146.862 80.1721L145.825 80.048L147.985 77.626L146.534 74.8772L147.584 75.0028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.539 75.599L153.143 76.8029C153.302 77.1153 153.429 77.402 153.566 77.7116L153.597 77.7144C153.807 77.4248 154.009 77.1781 154.215 76.9213L155.075 75.9057L156.093 76.0298L154.024 78.3206L155.521 81.2163L154.452 81.0879L153.832 79.8298C153.666 79.5046 153.527 79.195 153.383 78.8627L153.362 78.8598C153.153 79.1494 152.937 79.4076 152.707 79.6929L151.818 80.7698L150.78 80.6457L152.938 78.2222L151.49 75.4735L152.539 75.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.492 76.1981L158.097 77.4005C158.255 77.7129 158.384 77.9996 158.521 78.3078L158.552 78.312C158.76 78.0225 158.963 77.7743 159.17 77.5189L160.03 76.5033L161.047 76.626L158.979 78.9183L160.476 81.8139L159.405 81.6841L158.786 80.426C158.619 80.1008 158.482 79.7927 158.338 79.4589L158.315 79.4575C158.107 79.747 157.892 80.0038 157.662 80.2891L156.772 81.3674L155.734 81.2419L157.893 78.8198L156.444 76.0711L157.492 76.1981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.663 35.5092C191.069 40.4346 186.597 43.9465 181.67 43.3517L131.729 37.335C126.805 36.7416 123.293 32.2683 123.887 27.3429C124.48 22.416 128.953 18.9056 133.88 19.4989L183.82 25.517C188.745 26.1104 192.258 30.5837 191.663 35.5092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.942 42.4198L169.187 41.8478L171.335 24.0104L176.092 24.5838L173.942 42.4198Z",
    fill: "#031A6B",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.619 41.4181L158.485 40.558L160.633 22.7234L167.767 23.5821L165.619 41.4181Z",
    fill: "#031A6B",
    fillOpacity: 0.06
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2060_3760",
    x: 0.336164,
    y: 53.8621,
    width: 144.125,
    height: 105.448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.61207
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.61207
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2060_3760"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2060_3760",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2060_3760",
    x: 58.3362,
    y: 0.504288,
    width: 148.964,
    height: 106.086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.22414
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.61207
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2060_3760"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2060_3760",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer4);
export default __webpack_public_path__ + "static/media/Layer_4.03edbd12120dfcda071b1d43dce8d945.svg";
export { ForwardRef as ReactComponent };